import { Box, Typography } from "@mui/material";

interface ColorPreviewProps {
  color: string | null;
}

export const ColorPreview = ({ color }: ColorPreviewProps) => {
  if (!color)
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography color="text.secondary">—</Typography>
      </Box>
    );
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: "100%",
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: 0.5,
          backgroundColor: color,
          border: "1px solid",
          borderColor: "divider",
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.8rem",
          color: "text.primary",
        }}
      >
        {color}
      </Typography>
    </Box>
  );
};
